import React from 'react';
import LoginForm from './common/LoginForm';
import { connect } from "react-redux";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  DatePicker,
  MessageBar,
  MessageBarType,
  CheckboxVisibility
} from 'office-ui-fabric-react';
import axios from 'axios';
import {browserHistory} from 'react-router';

import imgCity from './imgs/city.jpg';
import imgLogo from './imgs/login-logo.png';
import request from 'axios';
import StatusBar from './common/StatusBar';
import config from '../config';
import _ from 'lodash';
import moment from 'moment';
const LabelCustom = (props) => {
  const {x, y, value} = props;

 return <text
  x={x}
  y={y}
  dy={10}
  dx={('' + value).length * 1}
  fill='#000'
  fontSize={10}
  transform={`rotate(${-90}, ${x}, ${y})`}>{value}</text>
};
export class StaffReporing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        isLoading: true,
        error: false,
        data: [],
        startDate: null,
        endDate: null
    }
  }
  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({
      isLoading: true
    });
    axios.get(config.apiUrl + '/customer/staff-report', {
      params: {
        start: this.state.startDate,
        end: this.state.endDate
      }
    })
      .then(({data}) => {
        this.setState({
          data: data,
          isLoading: false,
          error: false
        });
      })
      .catch((ex) => {
        this.setState({
          isLoading: false,
          error: true
        });
      });
  }

  changeDate(key, date) {
    this.setState({
      [key] : date
    });

    setTimeout(() => {
      this.loadData();
    }, 500);
  }


  widthChart() {
    try {
        var data = this.state.data;
        var v = data.length / 10;
        v = v > 1 ? v : 1;
        return Math.round(window.innerWidth * v);
    }
    catch (ex) {
        return 1000;
    }
  }

  heightChart() {
      try {
          return window.innerHeight - 100;
      }
      catch (ex) {
          return 600;
      }
  }

  render() {
    const { data, isLoading, error, startDate, endDate } = this.state;
    const {isDisplayChart, isDisplayTable} = this.props;
    if (error) {
      return <div>
        <MessageBar messageBarType={MessageBarType.error}>
          Load error
        </MessageBar>
      </div>
    }
    return (
      <div>
        <div className="ms-Grid" style={{marginTop: 10}}>
          <div className="ms-Grid-col ms-u-md5"></div>
          <div className="ms-Grid-col ms-u-md3">
            <DatePicker label='Start Date'
              className="one-line-100"
              formatDate={date => moment(date).format('MMM DD YYYY')}
              value={startDate ? new Date(startDate) : null}
              onSelectDate={date => this.changeDate('startDate', date)}
              allowTextInput
               />
              
          </div>
          <div className="ms-Grid-col ms-u-md1"></div>
          <div className="ms-Grid-col ms-u-md3">
            <DatePicker label='End Date'
              className="one-line-100"
              formatDate={date => moment(date).format('MMM DD YYYY')}
              value={endDate ? new Date(endDate) : null}
              onSelectDate={date => this.changeDate('endDate', date)}
              allowTextInput
              />
          </div>
        </div>
        {isLoading ?
          <Spinner size={SpinnerSize.large} /> :
          <div>
            { isDisplayChart == true &&
              <BarChart
                width={this.widthChart()}
                height={this.heightChart()}
                data={data}
                barGap={1}
                barCategoryGap={20}
                margin={{ top: 5, right: 30, left: 20, bottom: 30 }}>
                <XAxis dataKey="name" />
                <YAxis padding={{top: 50}} />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                <Legend />
                <Bar label={<LabelCustom />} name="Lead" dataKey="lead" fill="#106ebe" />
                <Bar label={<LabelCustom />} name="In Process" dataKey="inProcess" fill="#ffb900" />
                <Bar label={<LabelCustom />} name="No Answer" dataKey="noAnswer" fill="#d83b01" />
                <Bar label={<LabelCustom />} name="Discontinued" dataKey="discontinued" fill="#5c2d91" />
                <Bar label={<LabelCustom />} name="Not Interested" dataKey="notInterested" fill="#107c10" />
                <Bar label={<LabelCustom />} name="Wrong Number" dataKey="wrongNumber" fill="#00B294" />
              </BarChart>
            }
            { isDisplayTable != false &&
              <DetailsList
                items={data}
                columns={columns}
                checkboxVisibility={CheckboxVisibility.hidden}
                style={{ fontSize: 14 }}
              />
            }
          </div>
        }
      </div>
    )
  }

}

export default connect(state => ({
    auth: state.auth
}))(StaffReporing);

const columns = [
  {
    key: 'staff',
    name: 'Staff',
    fieldName: 'staff',
    onRender(item) {
      return item.fname + ' ' + item.lname;
    }
  },
  {
    key: 'lead',
    name: 'Lead',
    fieldName: 'lead',
    minWidth: 120,
    maxWidth: 120
  },
  {
    key: 'inprocess',
    name: 'In Process',
    fieldName: 'inProcess',
    minWidth: 120,
    maxWidth: 120
  },
  {
    key: 'notInterested',
    name: 'Not Interested',
    fieldName: 'notInterested',
    minWidth: 120,
    maxWidth: 120
  },
  {
    key: 'discontinued',
    name: 'Discontinued',
    fieldName: 'discontinued',
    minWidth: 120,
    maxWidth: 120
  },
  {
    key: 'wrongNumber',
    name: 'Wrong Number',
    fieldName: 'wrongNumber',
    minWidth: 120,
    maxWidth: 120
  },
  {
    key: 'noAnswer',
    name: 'No Answer',
    fieldName: 'noAnswer',
    minWidth: 120,
    maxWidth: 120
  },
  {
    key: 'total',
    name: 'Total',
    fieldName: 'total',
    minWidth: 120,
    maxWidth: 120,
    onRender(item) {
      return item.lead + item.inProcess + item.discontinued +
        item.notInterested + item.wrongNumber + item.noAnswer;
    }
  }
]


// WEBPACK FOOTER //
// ./client/components/StaffReporting.js